import {
  Box,
  Button,
  CircularProgress,
  Link as MaterialLink,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import ErrorTypography from '../../../shared/ErrorTypography/ErrorTypography';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Trans } from 'react-i18next';
import ConfirmDialog from '../ConfirmDialog/ConfirmDialog';
import { useDeleteResultMutation, useGetResultQuery } from '../../../store/data/dataSlice';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { togglePauseTut } from '../../../store/tutorial/tutorialSlice';

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

type Props = {
  rid: string;
};

const ResultsTable = ({ rid }: Props): JSX.Element => {
  const { data, error, isLoading } = useGetResultQuery({rid: rid});
  const tutorial = useAppSelector(state => state.tutorial);
  const dispatch = useAppDispatch();

  const handleClick = () => {
    if(tutorial.active && !tutorial.paused && tutorial.stepIndex == 25) {
      dispatch(togglePauseTut());
    }
  }

  if (error) {
    return <ErrorTypography message={'Error getting results'} />;
  } else {
    return (
      <div className='serviceTable'>
        <TableContainer>
          <TableHead>
             <TableRow>
               <TableCell>
              </TableCell>
              <TableCell>
                 <Trans>Service</Trans>
              </TableCell>
              <TableCell>Service ID</TableCell>
              <TableCell>
                <Trans>Preview</Trans>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {!isLoading && data ? (
              data.map(row => (
                <StyledTableRow key={row.service_id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                  <TableCell component={'th'} scope={'row'}>
                  </TableCell>
                  <TableCell component={'th'} scope={'row'}>
                    <MaterialLink underline={'hover'} component={Link} to={`/results/${row.result_id}/${row.service.id}`}
                      onClick={handleClick}
                    >
                      {row.service.name}
                    </MaterialLink>
                  </TableCell>
                  <TableCell>
                    {row.service.id}
                  </TableCell>
                  <TableCell>
                  <img width='100%' height='100%' src={`data:image/png;base64,${row.data_small}`} alt="visualization of the result"/>
                  </TableCell>
                </StyledTableRow>
              ))
            ) : (
              <Box sx={{ p: 2 }}>
                <CircularProgress />
              </Box>
            )}
          </TableBody>
        </TableContainer>
      </div>
    );
  }
};

export default ResultsTable;
